import React from 'react';
import CalculationChooser from "./CalculationChooser";
import {CalculatedOption, Item} from "../../config/interfaces";
import {Brand} from "../../config/enums";
import {KoluSet} from '../../config/interfaces';
import {insideUnitTypes, roomTypes} from "../../config/options";
import ImageGroupSelect from "../ImageGroupSelect";
import {cloneDeep} from 'lodash';

interface OptionsStepProps {
    calculatedOptions: CalculatedOption[];
    chosenBrand: Brand;
    setChosenBrand: (brand: Brand) => void;
    sets: KoluSet[];
    setSets: (sets: KoluSet[]) => void;
    aircoItems: Item[];
}

/**
 * A step in the stepper that gives options to choose the exterior layout of inside units.
 * @param {OptionsStepProps} props - The props that the OptionsStep component accepts.
 * @param {CalculatedOption[]} props.calculatedOptions - Array of calculated options, every brand that is selected has one option in this array.
 * @param {Brand} props.chosenBrand - The selected brand in the TotalOverviewDialog that is selected as the current outcome.
 * @param {Function} props.setChosenBrand - The function to change the chosen brand.
 * @param {KoluSet[]} props.sets - The sets of he chosen calculated option.
 * @param {Function} props.setSets - The function to update sets.
 * @constructor
 */
const OptionsStep = (props: OptionsStepProps) => {
    const {calculatedOptions, chosenBrand, setChosenBrand, sets, setSets, aircoItems} = props;

    return <>
        <h2 className={'mb-5'}>1. Kies je merk</h2>
        <CalculationChooser calculatedOptions={calculatedOptions} chosenBrand={chosenBrand} setChosenBrand={setChosenBrand} />
        <div className={'mt-5'}>
            <h2 className={'mb-5'}>2. Kies de gewenste opties</h2>
            {sets.map((set, i) => {
                let insideUnits = insideUnitTypes[chosenBrand];
                // If this is a single split we're going to filter the possibilities, because not all options might be available then...
                if (set.item?.aantalKamers === 1) {
                    const idLeftPart = set.item!.id.split('-')[0];
                    insideUnits = insideUnits.filter(unit => {
                        const newId = idLeftPart + '-' + unit.name;
                        return aircoItems.filter(ai => ai.id === newId).length > 0;
                    })
                } else {
                    // Remove comfora from options when multi split, because it's not available there for some very weird reason...
                    insideUnits = insideUnits.filter(iu => iu.name !== 'CO');
                }
                return <React.Fragment key={i}>
                    {i !== 0 && <hr />}
                    <h3>Combinatie #{i + 1}</h3>
                    {set.rooms.map((room, j) => {
                        const roomTypeName = roomTypes.filter(r => r.key === room.type)[0].name;
                        return <React.Fragment key={`${i}-${j}`}>
                            <h4 className={'mb-0 mt-3'}>{roomTypeName}</h4>
                            <span className={'text-muted d-block small'} style={{fontSize: 14}}>{roomTypeName}, {room.surface} m²</span>
                            <ImageGroupSelect small hideNames hoverEffect options={insideUnits} value={room.unitDesign} onChange={(e: string) => {
                                const setsCopy = cloneDeep(sets);
                                setsCopy[i].rooms[j].unitDesign = e;
                                setSets(setsCopy);
                            }} />
                        </React.Fragment>
                    })}
                </React.Fragment>
            })}
        </div>
    </>
};

export default OptionsStep;